<template>
  <div class="question-time">
    <van-datetime-picker
      class="time-component"
      v-model="currentDate"
      type="date"
      :title="data.que_title"
      :min-date="minDate"
      :show-toolbar="false"
      :max-date="maxDate"
      :columns-order="['year', 'month', 'day']"
      :formatter="formatter"
      @change="bindConfirm"
      @cancel="bindCancel"
    />
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      minDate: new Date('1923/1/1'),
      maxDate: new Date(),
      showTime: false,
      currentDate: new Date()
    }
  },
  computed: {
    timeValue() {
      if (this.data.value) {
        let arr = this.data.value.split('-')
        if (arr.length == 3) {
          return arr[0] + '年' + arr[1] + '月' + arr[2] + '日'
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  },
  created() {},
  methods: {
    bindClick() {
      this.showTime = true
    },
    bindConfirm(timeObj) {
      let str = this.getTimeStr(timeObj)
      this.data.value = str
      this.$emit('change', str)
      this.showTime = false
    },
    getTimeStr(timeObj) {
      let arr = timeObj.getValues()
      let year = arr[0].slice(0, arr[0].length - 1)
      let month = arr[1].slice(0, arr[1].length - 1)
      let day = arr[2].slice(0, arr[2].length - 1)
      return year + '-' + month + '-' + day
    },
    bindCancel() {
      this.showTime = false
    },
    formatter(type, val) {
      if (type === 'year') {
        return val + '年'
      }
      if (type === 'month') {
        return val + '月'
      }
      if (type === 'day') {
        return val + '日'
      }
      return val
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .van-picker-column__item--selected {
  font-size: 22px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #27243c;
}

.question-time {
  text-align: center;
  margin-top: 10vh;
}

.text {
  padding: 0px 20px;
  box-sizing: border-box;
  display: inline-block;
  max-width: 100%;
  min-width: 160px;
  height: 44px;
  line-height: 44px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 22px;
  border: 3px solid rgba(159, 145, 254, 1);
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #373d52;

  .desc {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.3);
  }
}
</style>
